//------------------------------------------------------------------------
// Setup Font Face Observer to check when fonts have loaded
// https://fontfaceobserver.com
// https://www.filamentgroup.com/lab/font-events.html
// https://jonsuh.com/blog/font-loading-with-font-events/
// Note: This will no longer be necessary once `font-display` is supported
// http://caniuse.com/#feat=css-font-rendering-controls
//------------------------------------------------------------------------

'use strict';

// CustomEvents polyfill
import 'custom-event-polyfill';

// Font face observer script allows us to detect when web fonts have been downloaded
// NOTE: The main file in “fontfaceobserver” doesn’t include the Promise polyfill so we’re linking to the one that does
import FontFaceObserver from 'fontfaceobserver/fontfaceobserver';

// Only run if fonts have not been previously loaded
if ('localStorage' in window && !localStorage.fontsLoaded) {
  var htmlEl = document.documentElement;

  // Create new instance of FontFaceObserver for each font file
  var metricRegular = new FontFaceObserver('Metric Regular', { weight: 300 });
  var metricBold = new FontFaceObserver('Metric Bold', { weight: 700 });

  // Promise polyfill provided by fontfaceobserver.js
  Promise.all([metricBold.load(), metricRegular.load()])
    .then(function() {
      // Add class
      htmlEl.className += ' fonts-loaded';

      // Set local storage var
      // Key name needs to be updated if you add new fonts
      // fontsLoadedv2 etc.
      localStorage.fontsLoaded = true;

      // Emit font-loaded event
      if (htmlEl.className.indexOf('lte-ie8') === -1) {
        var triggerEvent = function() {
          // CustomEvent requires custom-event-polyfill for IE9+ (no support in IE8-
          var fontEvent = new CustomEvent('fonts-loaded');
          htmlEl.dispatchEvent(fontEvent);
        };

        // Use setTimeout to allow browser to paint first
        window.setTimeout(triggerEvent, 0);
      }
    })
    .catch(function() {
      console.warn('Could not resolve Promise that webfonts loaded');
    });
}



// WEBPACK FOOTER //
// ./app/javascript/modules/font-face.js